export default [
  {
    id: 1,
    name: 'Female',
    label: 'Female',
    value: 'female',
    legal_gender_system_code: 'F',
  },
  {
    id: 2,
    name: 'Male',
    label: 'Male',
    value: 'male',
    legal_gender_system_code: 'M',
  },
  {
    id: 3,
    name: 'NS',
    label: 'NS',
    value: 'not_specified',
    legal_gender_system_code: 'NS',
  },
];
